import React from 'react';
import { useSite, IMG } from '../components/StoreLayout';
import useSEO from '../useSEO';

function parseJson(v, fallback) {
  try { const p = JSON.parse(v || ''); return Array.isArray(p) ? p : fallback; } catch { return fallback; }
}

export default function WhyChooseUs() {
  const { content: c } = useSite();

  useSEO({
    title: c['page.why-choose-us.meta_title'] || 'Why Choose Us',
    description: c['page.why-choose-us.meta_description'],
    canonical: `${window.location.origin}/store/page/why-choose-us`,
  });

  const gridItems = parseJson(c['page.why-choose-us.grid_items'], []);
  const detailItems = parseJson(c['page.why-choose-us.detail_items'], []);
  const checklistItems = parseJson(c['page.why-choose-us.checklist_items'], []);
  const heading = c['page.why-choose-us.heading'] || 'Why Businesses Around the World Choose';

  return (
    <div style={{ background: 'var(--sf-body-bg)' }}>
      {/* HERO */}
      <section style={{ maxWidth: 900, margin: '0 auto', padding: '56px 24px 20px', textAlign: 'center' }}>
        {c['page.why-choose-us.badge'] && (
          <span style={{
            display: 'inline-block', background: 'var(--sf-primary)', color: '#fff', fontSize: 11.5, fontWeight: 700,
            letterSpacing: 1.4, textTransform: 'uppercase', padding: '6px 18px', borderRadius: 20, marginBottom: 20,
          }}>
            {c['page.why-choose-us.badge']}
          </span>
        )}
        <h1 style={{ fontSize: 'clamp(26px,4vw,38px)', fontWeight: 800, lineHeight: 1.25, color: 'var(--sf-primary)', margin: '0 0 16px' }}>
          {heading}
          {' '}<span style={{ color: 'var(--sf-hover)' }}>Prakaash Eyewear</span>
        </h1>
        {c['page.why-choose-us.subheading'] && (
          <p style={{ fontSize: 15.5, color: 'var(--sf-muted)', maxWidth: 620, margin: '0 auto', lineHeight: 1.7 }}>
            {c['page.why-choose-us.subheading']}
          </p>
        )}
      </section>

      {/* ICON GRID */}
      {gridItems.length > 0 && (
        <section style={{ maxWidth: 1200, margin: '20px auto 0', padding: '0 24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 18 }}>
            {gridItems.map((g, i) => (
              <div key={i} className="wcu-grid-card" style={{
                background: '#fff', border: '1px solid #eee', borderRadius: 14, padding: '26px 20px', textAlign: 'center',
              }}>
                <div style={{
                  width: 54, height: 54, borderRadius: '50%', background: 'color-mix(in srgb, var(--sf-accent) 22%, #fff)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
                }}>
                  <i className={`ti ti-${g.icon}`} style={{ fontSize: 24, color: 'var(--sf-primary)' }} />
                </div>
                <h3 style={{ fontSize: 14.5, fontWeight: 700, color: 'var(--sf-primary)', margin: '0 0 8px' }}>{g.title}</h3>
                <p style={{ fontSize: 12.5, color: 'var(--sf-muted)', lineHeight: 1.65, margin: 0 }}>{g.text}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* INTRO + DETAIL SECTIONS (left) / SIDEBAR (right) */}
      <section style={{ maxWidth: 1200, margin: '56px auto 0', padding: '0 24px 64px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1.7fr) minmax(260px,1fr)', gap: 40, alignItems: 'start' }} className="wcu-two-col">
          <div>
            {c['page.why-choose-us.intro_heading'] && (
              <h2 style={{ fontSize: 24, fontWeight: 800, color: 'var(--sf-primary)', margin: '0 0 6px' }}>
                Your Trusted Wholesale Eyewear Partner <span style={{ color: 'var(--sf-hover)' }}>Since 1978</span>
              </h2>
            )}
            {['intro_para1', 'intro_para2', 'intro_para3'].map(k => c[`page.why-choose-us.${k}`] && (
              <p key={k} style={{ fontSize: 14.5, color: 'var(--sf-muted)', lineHeight: 1.8, margin: '14px 0 0' }}>
                {c[`page.why-choose-us.${k}`]}
              </p>
            ))}

            <div style={{ marginTop: 30 }}>
              {detailItems.map((d, i) => (
                <div key={i} style={{ display: 'flex', gap: 16, padding: '18px 0', borderTop: i > 0 ? '1px solid #eee' : 'none' }}>
                  <div style={{
                    width: 42, height: 42, flexShrink: 0, borderRadius: 10, background: 'color-mix(in srgb, var(--sf-accent) 20%, #fff)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <i className={`ti ti-${d.icon}`} style={{ fontSize: 19, color: 'var(--sf-primary)' }} />
                  </div>
                  <div>
                    <h3 style={{ fontSize: 15.5, fontWeight: 700, color: 'var(--sf-primary)', margin: '0 0 6px' }}>{d.title}</h3>
                    <p style={{ fontSize: 13.5, color: 'var(--sf-muted)', lineHeight: 1.75, margin: 0 }}>{d.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 16, padding: 24, position: 'sticky', top: 20 }}>
            {c['page.why-choose-us.sidebar_heading'] && (
              <h3 style={{ fontSize: 16.5, fontWeight: 800, color: 'var(--sf-primary)', margin: '0 0 16px' }}>
                {c['page.why-choose-us.sidebar_heading']}
              </h3>
            )}
            {checklistItems.map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 9, padding: '6px 0', fontSize: 13, color: 'var(--sf-primary)' }}>
                <i className="ti ti-circle-check-filled" style={{ fontSize: 16, color: 'var(--sf-hover)', flexShrink: 0, marginTop: 1 }} />
                <span>{item.title}</span>
              </div>
            ))}
            {c['page.why-choose-us.sidebar_footnote'] && (
              <p style={{ fontSize: 10.5, color: 'var(--sf-muted)', marginTop: 14, lineHeight: 1.6 }}>
                {c['page.why-choose-us.sidebar_footnote']}
              </p>
            )}
            {c['page.why-choose-us.sidebar_image'] && (
              <img src={IMG(c['page.why-choose-us.sidebar_image'])} alt="" style={{ width: '100%', borderRadius: 12, marginTop: 18, display: 'block' }} />
            )}
          </div>
        </div>
      </section>

      {/* CTA BANNER */}
      {c['page.why-choose-us.cta_heading'] && (
        <section style={{ background: 'var(--sf-primary)', color: '#fff' }}>
          <div style={{ maxWidth: 1200, margin: '0 auto', padding: '34px 24px', display: 'flex', flexWrap: 'wrap', gap: 24, alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, flex: '1 1 280px' }}>
              <div style={{
                width: 46, height: 46, borderRadius: '50%', background: 'rgba(255,255,255,0.12)', flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <i className="ti ti-heart-handshake" style={{ fontSize: 22, color: '#fff' }} />
              </div>
              <div>
                <h3 style={{ fontSize: 18, fontWeight: 800, margin: '0 0 4px' }}>{c['page.why-choose-us.cta_heading']}</h3>
                {c['page.why-choose-us.cta_text_left'] && (
                  <p style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.75)', lineHeight: 1.65, margin: 0, maxWidth: 480 }}>
                    {c['page.why-choose-us.cta_text_left']}
                  </p>
                )}
              </div>
            </div>
            {c['page.why-choose-us.cta_text_right'] && (
              <p style={{ flex: '1 1 280px', fontSize: 12.5, color: 'rgba(255,255,255,0.75)', lineHeight: 1.65, margin: 0, borderLeft: '1px solid rgba(255,255,255,0.15)', paddingLeft: 24 }}
                className="wcu-cta-right">
                {c['page.why-choose-us.cta_text_right']}
              </p>
            )}
          </div>
        </section>
      )}

      <style>{`
        @media (max-width: 820px) {
          .wcu-two-col { grid-template-columns: 1fr !important; }
          .wcu-cta-right { border-left: none !important; padding-left: 0 !important; }
        }
        .wcu-grid-card { transition: transform .18s ease, box-shadow .18s ease; }
        .wcu-grid-card:hover { transform: translateY(-3px); box-shadow: 0 10px 26px rgba(0,0,0,0.07); }
      `}</style>
    </div>
  );
}
